module.exports = __webpack_public_path__ + "0022d8534743e8004c942503fea64d41.svg";